import React from "react";
import Link from "gatsby-link";
import styles from "./CollaboratorsList.module.scss";
import { importImages, truncate } from "../../utils/helpers";
// import Img from "gatsby-image";

const images = importImages(
	require.context("../../images/collaborators", false, /\.(pn?g)$/)
);
const renderItems = (array = [], locale = "en-US") => {
	return array.map((item, i) => {
		return (
			<div
				key={"list-" + i}
				className={
					"row justify-content-center justify-content-md-between " +
					styles.bottom_line
				}
			>
				<div className="col-10 col-md-3  col-lg-3">
					<div className={styles.row}>
						<div className={styles.line}>
							<div
								className={"img_fill " + styles.image_bg_fill}
								style={{
									backgroundImage:
										"url(" + item.logo.sizes.src + ")"
								}}
							/>
							{/* <img src={item.logo.sizes.src} alt={item.name}/> */}
							{/* <Img
							title={item.name}
							alt={item.name}
							sizes={item.logo.sizes}
							className="img_fill"
							style={{ marginBottom: "1rem" }}
						/> */}
						</div>
					</div>
				</div>
				<div className={styles.lineBetween} />
				<div className={"col-12 col-md-8  col-lg-8 " + styles.line}>
					{item.collaborator ? (
						item.collaborator.map((collaborator, ix) => {
							return (
								<div key={ix}>
									<b className={styles.collaborator_name}>
										{collaborator.name}
										{collaborator.title && ", "}{" "}
										{collaborator.title}
									</b>
									<ul
										className={
											"list-unstyled " +
											styles.project_item
										}
									>
										{collaborator.project &&
											collaborator.project.map(
												(project, i) => {
													return (
														<li key={i}>
															{truncate(
																project.title,
																70,
																true
															)}{" "}
															-{" "}
															<Link
																to={
																	"/" +
																	locale +
																	"/research/projects/" +
																	project.slug
																}
																style={{
																	whiteSpace:
																		"nowrap"
																}}
															>
																{locale === "th"
																	? "รายละเอียดโครงการ"
																	: "see project"}{" "}
																&raquo;
															</Link>
														</li>
													);
												}
											)}
									</ul>
								</div>
							);
						})
					) : (
						<div>
							<b className={styles.collaborator_name}>
								{item.name}
							</b>
						</div>
					)}
				</div>
			</div>
		);
	});
};

const CollaboratorsList = ({ className, list, type, locale }) => {
	return <div className={className}>{renderItems(list, locale)}</div>;
};

export default CollaboratorsList;



// WEBPACK FOOTER //
// ./src/components/CollaboratorsList/index.js